import { useLanguageStore } from '@/stores/useLanguageStore'
import type { EnumLabelLanguage } from '@/utils/enum-label'

const localeByLanguage: Record<EnumLabelLanguage, string> = {
  th: 'th-TH',
  en: 'en-GB',
}

export function useAppLocale() {
  const language = useLanguageStore(state => state.language)

  return localeByLanguage[language] ?? 'en-GB'
}
